export enum PaymentType {
  CREDIT = 'CREDIT',
  BANK_SLIP = 'BANK_SLIP'
}
